export default "__VITE_ASSET__CtTcGKPa__"